import { combineReducers } from "redux";
import pick_drop_charges from "../features/serviceadmin/pick_drop_charges/Slice";

const ManagePickDropCharges = combineReducers({
  pick_drop_charges: pick_drop_charges,
});

export default ManagePickDropCharges;
